class CountdownBanner extends HTMLElement {
  connectedCallback() {
    this.endDate = this.dataset.endDate;
    this.timer = this.querySelector('[data-timer]');
    this.expiredMessage = this.querySelector('[data-expired]');
    this.daysEl = this.querySelector('[data-days]');
    this.hoursEl = this.querySelector('[data-hours]');
    this.minutesEl = this.querySelector('[data-minutes]');
    this.secondsEl = this.querySelector('[data-seconds]');

    if (!this.endDate || !this.timer) return;

    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  updateCountdown() {
    const now = new Date().getTime();
    const end = new Date(this.endDate).getTime();

    if (isNaN(end)) {
      console.warn('Countdown banner: could not parse end date "' + this.endDate + '". Check the date settings in the theme editor.');
      clearInterval(this.interval);
      return;
    }

    const distance = end - now;

    if (distance < 0) {
      this.timer.style.display = 'none';
      if (this.expiredMessage) this.expiredMessage.classList.add('active');
      clearInterval(this.interval);
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    this.daysEl.textContent = String(days).padStart(2, '0');
    this.hoursEl.textContent = String(hours).padStart(2, '0');
    this.minutesEl.textContent = String(minutes).padStart(2, '0');
    this.secondsEl.textContent = String(seconds).padStart(2, '0');
  }
}

if (!customElements.get('countdown-banner')) {
  customElements.define('countdown-banner', CountdownBanner);
}
